import React, {useEffect} from 'react';
import {createPortal} from 'react-dom';
import IconXMark from "@/assets/icons/x-mark.svg?react";
import VibratingButton from "@/components/base/button/VibratingButton.tsx";

interface Props {
    open: boolean;
    children: React.ReactNode;
    image?: string;
    onClose?: () => void;
}

const BaseModal = ({open = true, onClose, children, image = 'images/patterns/check-in-modal.webp'}: Props) => {

    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [open]);

    return (
        <>
            {
                open &&
                createPortal(
                    <div className="fixed inset-0 z-50 flex-center bg-dark/80 p-4">
                        <div
                            className="max-w-[310px] bg-gray-linear rounded-20 p-4 pt-16 relative after:pointer-events-none after:z-0 after:absolute after:inset-0 after:border-2 after:border-white/08 after:rounded-20">
                            {children}

                            <img
                                className="absolute left-1/2 -translate-x-1/2 top-0 -translate-y-1/2 w-[200px] aspect-square pointer-events-none z-10"
                                src={image} alt=""/>
                            <VibratingButton className="rounded-full bg-white/08 p-1.5 absolute top-4 right-4 z-0"
                                    onClick={onClose}>
                                <IconXMark width="16" height="16"/>
                            </VibratingButton>
                        </div>
                    </div>,
                    document.body)
            }
        </>
    );
};

export default BaseModal;